import styled from 'styled-components'

export const ListingItems = styled.div`
  padding-top: 25px;
  padding-bottom: 25px;
  border-top: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
  border-bottom: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
  flex: 1;
  margin-right: 20px;
  padding-left: 10px;

  & + & {
    border-top: none;
  }

  .Listing__Item-Date {
    color: ${({ theme }) => theme.webMktNewPalette.alphaBlack[30]};
    margin-bottom: 8px;
  }

  a:hover,
  a:focus {
    .Listing__Item-Title {
      color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
      text-decoration: underline;
    }
  }
`

export const ListingsTypeContainer = styled.div`
  display: flex;
  margin-top: 16px;

  .Listing__Type-Seperator {
    margin-left: 16px;
    margin-right: 16px;
  }

  .Listing__Item-Type {
    margin-right: 10px;
    color: ${({ theme }) => theme.webMktNewPalette.black};
  }

  .Listing__Item-Publication {
    color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
  }
`
